import { render, staticRenderFns } from "./editUserPassword.vue?vue&type=template&id=2467dc6f&scoped=true&"
import script from "./editUserPassword.vue?vue&type=script&lang=js&"
export * from "./editUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./editUserPassword.vue?vue&type=style&index=0&id=2467dc6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467dc6f",
  null
  
)

export default component.exports